import PedidoVendaLink, { semCamposInternos } from "components/PedidoVendaLink";
import { Alert, Box, Button, Card, Grid, Icon, TextField } from "@mui/material";
import MDBox from "components/MDBox";
import MDTypography from "components/MDTypography";
import Footer from "examples/Footer";
import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
import { format } from "utils/formatDate";

import { DataGridPro as DataGrid } from "@mui/x-data-grid-pro";
import MDButton from "components/MDButton";
import { useFormik } from "formik";
import AdicionarCliente from "layouts/clientes";
import {
  STATUS_PEDIDO,
  findStatusPedido,
} from "layouts/pedidos-venda/components/yupSchema";
import { useEffect, useState } from "react";
import { exportToExcel } from "react-json-to-excel";
import Service from "services/receivables";
import { ptBR_DataGrid } from "utils/datagrid";
import { commaToDot, dotToComma } from "utils/numberComma";
import * as XLSX from "xlsx";

const initialValues = {
  startDate: "",
  endDate: "",
  customer: null,
  status: "",
};

export default function AcertoCliente() {
  const [loading, setLoading] = useState(false);
  const [report, setReport] = useState([]);
  const [originalReport, setOriginalReport] = useState([]);

  const [showAddCliente, setShowAddCliente] = useState(false);
  const [childData, setChildData] = useState({});

  const [totalListado, setTotalListado] = useState(0);
  const [totalReceber, setTotalReceber] = useState(0);

  const widths = [110, 60, 140, 60, 60, 60, 60, 60, 140, 140, 110, 130];

  const formik = useFormik({
    initialValues: initialValues,
    onSubmit: async (values) => {
      setLoading(true);

      try {
        const rows = await Service.agreementWithCustomers({
          ...values,
          customer: values.customer?._id || values.customer,
        });

        setTotalListado(
          rows.reduce((acc, row) => acc + Number(row.purchase?.valorTotal), 0)
        );

        setTotalReceber(
          rows.reduce(
            (acc, row) =>
              acc +
              (Number(row.sale?.valorTotal) -
                Number(row.sale?.totalPagarFrete || 0)),
            0
          )
        );

        setOriginalReport(rows);
        const agreements = await parseAgreements(rows);

        if (!agreements.length) {
          alert("Nenhum resultado encontrado");
        }

        setReport(agreements);

        setLoading(false);
      } catch (error) {
        console.log(error);
      }

      setLoading(false);
    },
  });

  const parseAgreements = async (rows) => {
    if (!rows || rows.length === 0) return [];
    const data = rows.map((row) => {
      const primeiroProduto =
        row.purchase?.products?.length > 0 && row.purchase?.products !== null
          ? row.purchase?.products[0]
          : {};

      const primeiroProdutoVenda =
        row.sale?.products?.length > 0 && row.sale?.products !== null
          ? row.sale?.products[0]
          : {};

      if (row.sale?.valorTotal === 0 || !row.sale?.valorTotal) {
        row.sale.valorTotal = row.sale?.products?.reduce((acc, product) => {
          return acc + Number(product.price) * Number(product.quantity);
        }, 0);
      }

      if (row.purchase?.valorTotal === 0 || !row.purchase?.valorTotal) {
        row.purchase.valorTotal = row.purchase?.products?.reduce(
          (acc, product) => {
            return acc + Number(product.price) * Number(product.quantity);
          },
          0
        );
      }

      const purchase = row.purchase;

      const totalFrete =
        Number(commaToDot(purchase.carregamento)) +
        Number(commaToDot(purchase.valorFrete)) +
        Number(commaToDot(purchase.valorIcms));

      const totalPagarFrete =
        totalFrete - Number(commaToDot(purchase.adiantamentoFrete));

      let totalFinal = totalPagarFrete + 0;
      let totalQtdProdutos = 0;

      purchase.products?.forEach((produto) => {
        totalFinal += produto.price * produto.quantity;
        totalQtdProdutos += produto.quantity;
      });

      let custoUnitario = totalFinal > 0 ? totalFinal / totalQtdProdutos : 0;

      return {
        Emissão: format(new Date(row.purchase?.data), "dd/MM/yyyy"),
        _saleId: row.sale?._id,
        Pedido: row.purchase?.numPedido + row.sale?.letterPedido,
        "Descrição do Produto":
          primeiroProdutoVenda?.product?.descricao ||
          primeiroProduto?.product?.descricao ||
          "",
        "Vlr. Unit.": Number(
          primeiroProdutoVenda?.price || primeiroProduto?.price || 0
        ).toFixed(2),
        "Custo Unitário": Number(custoUnitario).toFixed(2),
        "Peso Líquido": Number(row.sale?.pesoLiquido),
        "Peso Líquido à Pagar": row.sale?.pesoLiquido
          ? Number(row.sale?.pesoLiquido * 0.9).toFixed(2)
          : "",
        "Vlr. Total": row.sale?.valorTotal
          ? Number(row.sale.valorTotal * 0.9).toFixed(2)
          : "",
        Turma: row.sale?.turma,
        Carregamento: row.sale?.carregamento,
        Descarga: Number(row.sale.valorDescarga).toFixed(2),
        Transportadora:
          row.sale?.shippingCompany?.nomeFantasia ||
          row.sale?.shippingCompany?.razaoSocial ||
          row.sale?.motorista,
        Veículo: row.sale?.caminhao,
        Status: findStatusPedido(row.sale?.status) || "",
        "Total à Receber": row.sale?.valorTotal
          ? Number(Number(row.sale?.valorTotal)).toFixed(2)
          : "",
      };
    });

    return data;
  };

  const descobreTurma = (pesoLiquido) => {
    if (pesoLiquido < 17000) {
      return 400;
    } else if (pesoLiquido >= 17000 && pesoLiquido < 22000) {
      return 600;
    } else {
      return 900;
    }
  };

  const printAgreements = (agreements) => {
    // Criar um novo workbook
    const workbook = XLSX.utils.book_new();

    // Converter os dados para worksheet
    const worksheet = XLSX.utils.json_to_sheet(agreements);

    // Definir tipos de dados para colunas específicas
    const range = XLSX.utils.decode_range(worksheet["!ref"]);

    for (let col = range.s.c; col <= range.e.c; col++) {
      const colLetter = XLSX.utils.encode_col(col);
      const headerCell = worksheet[colLetter + "1"];

      if (headerCell) {
        const headerValue = headerCell.v;

        // Definir formato numérico para colunas de valores
        if (
          headerValue.includes("Vlr.") ||
          headerValue.includes("Custo") ||
          headerValue.includes("Turma") ||
          headerValue.includes("Descarga") ||
          headerValue.includes("Total à Receber") ||
          headerValue.includes("Peso Líquido à Pagar")
        ) {
          for (let row = range.s.r + 1; row <= range.e.r; row++) {
            const cellAddress = colLetter + (row + 1);
            const cell = worksheet[cellAddress];

            if (cell && cell.v !== "-" && cell.v !== "") {
              // Converter para número se for string
              if (typeof cell.v === "string") {
                cell.v = parseFloat(cell.v.replace(",", "."));
              }
              // Definir formato numérico
              cell.t = "n";
              cell.z = "#,##0.00";
            }
          }
        }
      }
    }

    // Adicionar a worksheet ao workbook
    XLSX.utils.book_append_sheet(workbook, worksheet, "Acerto Cliente");

    // Gerar e baixar o arquivo Excel
    XLSX.writeFile(
      workbook,
      "acerto_cliente_" + new Date().getTime() + ".xlsx"
    );
  };

  const selectParent = (parent, value) => {
    formik.setFieldValue(parent, value);
  };

  useEffect(() => {
    const closeOnEscapePressed = (e) => {
      if (e.key === "Escape") {
        if (showAddCliente) setShowAddCliente(false);
      }
    };
    window.addEventListener("keydown", closeOnEscapePressed);
    return () => window.removeEventListener("keydown", closeOnEscapePressed);
  }, [showAddCliente]);

  const EditField = ({ value }) => {
    return (
      <TextField
        // id={fieldName}
        // name={fieldName}
        value={value}
        // onChange={onChange}
        disabled={loading}
        sx={{
          width: "100%",
        }}
      />
    );
  };

  return (
    <DashboardLayout>
      <MDBox pt={3} pb={3}>
        <Grid container spacing={6}>
          <Grid item xs={12}>
            <Card>
              <MDBox
                mx={2}
                mt={-3}
                py={3}
                px={2}
                variant="gradient"
                bgColor="info"
                borderRadius="lg"
                coloredShadow="info"
                sx={{ display: "flex", justifyContent: "space-between" }}
              >
                <MDTypography variant="h6" color="white" mt={1}>
                  Relatório de Acerto com Cliente
                </MDTypography>
              </MDBox>
              <MDBox pt={3} mx={2} py={3} px={2}>
                <Box
                  sx={{
                    display: "grid",
                    gridTemplateColumns: "repeat(2, 1fr)",
                    gap: 2,
                    mb: 2,
                  }}
                  component="form"
                  onSubmit={formik.handleSubmit}
                >
                  <TextField
                    id="startDate"
                    name="startDate"
                    label="Data Inicial"
                    type="date"
                    value={formik.values.startDate}
                    onChange={formik.handleChange}
                    onBlur={formik.handleBlur}
                    disabled={loading}
                    error={
                      formik.touched.startDate &&
                      Boolean(formik.errors.startDate)
                    }
                    helperText={
                      formik.touched.startDate && formik.errors.startDate
                    }
                    sx={{
                      width: "100%",
                    }}
                    InputLabelProps={{
                      shrink: true,
                    }}
                  />

                  <TextField
                    id="endDate"
                    name="endDate"
                    label="Data Final"
                    type="date"
                    value={formik.values.endDate}
                    onChange={formik.handleChange}
                    onBlur={formik.handleBlur}
                    disabled={loading}
                    error={
                      formik.touched.endDate && Boolean(formik.errors.endDate)
                    }
                    helperText={formik.touched.endDate && formik.errors.endDate}
                    sx={{
                      width: "100%",
                    }}
                    InputLabelProps={{
                      shrink: true,
                    }}
                  />

                  <Alert
                    icon={false}
                    severity="success"
                    action={
                      <MDButton
                        variant="gradient"
                        color="info"
                        fullWidth
                        iconOnly
                        onClick={() => setShowAddCliente(true)}
                      >
                        <Icon fontSize="small">edit</Icon>
                      </MDButton>
                    }
                  >
                    <b>Cliente: </b>
                    {childData.customer?.razaoSocial ||
                      childData.customer?.nomeFantasia}
                  </Alert>

                  <TextField
                    id="status"
                    name="status"
                    label="Status"
                    value={formik.values.status}
                    onChange={formik.handleChange}
                    onBlur={formik.handleBlur}
                    disabled={loading}
                    error={
                      formik.touched.status && Boolean(formik.errors.status)
                    }
                    helperText={formik.touched.status && formik.errors.status}
                    sx={{
                      width: "100%",
                    }}
                    select
                    SelectProps={{
                      native: true,
                    }}
                  >
                    <option aria-label="Selecione" value="" />

                    {Object.values(STATUS_PEDIDO).map((opcao) => (
                      <option key={opcao} value={opcao}>
                        {findStatusPedido(opcao)}
                      </option>
                    ))}
                  </TextField>

                  <Button
                    type="submit"
                    variant="contained"
                    disabled={loading}
                    sx={{
                      gridColumn: "span 2",
                      justifySelf: "center",
                      width: "100%",
                      color: "white !important",
                    }}
                  >
                    {loading ? "Carregando..." : "Gerar Relatório"}
                  </Button>
                </Box>
              </MDBox>
            </Card>

            {report.length > 0 && (
              <>
                <Card sx={{ marginTop: 4 }}>
                  <DataGrid
                    initialState={{
                      pagination: { paginationModel: { pageSize: 100 } },
                    }}
                    pageSizeOptions={[100, 200]}
                    rows={report.map((row, index) =>
                      Object({ ...row, id: index })
                    )}
                    columns={Object.keys(report[0])
                      .filter((key) => !key.startsWith("_"))
                      .map((key, idx) =>
                        Object({
                          headerName: key,
                          field: key,
                          flex: 1,
                          idx: idx,
                          minWidth: widths[idx],
                          ...(key === "Pedido" && {
                            renderCell: (params) => (
                              <PedidoVendaLink saleId={params.row._saleId}>
                                {params.value}
                              </PedidoVendaLink>
                            ),
                          }),
                        })
                      )}
                    rowCount={report.length}
                    rowSelection={false}
                    localeText={ptBR_DataGrid}
                    sx={{
                      ".MuiDataGrid-virtualScroller": {
                        minHeight: "100px",
                      },
                    }}
                    disableColumnFilter
                    headerFilters
                    slots={{
                      headerFilterMenu: null,
                    }}
                  />
                </Card>

                <Box
                  sx={{
                    display: "flex",
                    justifyContent: "flex-end",
                    p: 2,
                  }}
                >
                  <Button
                    variant="contained"
                    onClick={() => printAgreements(semCamposInternos(report))}
                    sx={{
                      color: "white !important",
                    }}
                  >
                    Exportar para Excel
                  </Button>
                </Box>
              </>
            )}

            {(totalListado > 0 || totalReceber > 0) && (
              <Card sx={{ marginTop: 4 }}>
                <MDBox
                  mx={2}
                  mt={-3}
                  py={3}
                  px={2}
                  variant="gradient"
                  bgColor="info"
                  borderRadius="lg"
                  coloredShadow="info"
                  sx={{ display: "flex", justifyContent: "space-between" }}
                >
                  <MDTypography variant="h6" color="white" mt={1}>
                    Totais
                  </MDTypography>
                </MDBox>
                <MDBox pt={3} mx={2} py={3} px={2}>
                  <Grid container spacing={2}>
                    <Grid item xs={6}>
                      <MDTypography variant="h6" color="info">
                        Total Listado
                      </MDTypography>
                    </Grid>
                    <Grid item xs={6}>
                      <MDTypography variant="h6" color="info">
                        {new Intl.NumberFormat("pt-BR", {
                          style: "currency",
                          currency: "BRL",
                        }).format(totalListado)}
                      </MDTypography>
                    </Grid>

                    <Grid item xs={6}>
                      <MDTypography variant="h6" color="info">
                        Total à Receber
                      </MDTypography>
                    </Grid>
                    <Grid item xs={6}>
                      <MDTypography variant="h6" color="info">
                        {new Intl.NumberFormat("pt-BR", {
                          style: "currency",
                          currency: "BRL",
                        }).format(totalReceber)}
                      </MDTypography>
                    </Grid>
                  </Grid>
                </MDBox>
              </Card>
            )}
          </Grid>
        </Grid>
      </MDBox>

      {showAddCliente && (
        <MDBox
          pt={"30px"}
          pb={"5%"}
          px={"5%"}
          sx={{
            position: "absolute",
            zIndex: 9999,
            width: "100vw",
            minHeight: "100vh",
            height: "100%",
            backgroundColor: "rgba(0,0,0,0.5)",
            backdropFilter: "blur(5px)",
            top: 0,
            right: 0,
            overflow: "auto",
          }}
        >
          <AdicionarCliente
            fromParent={true}
            selectParent={(value) => {
              setChildData((prevState) =>
                Object({ ...prevState, customer: value })
              );
              selectParent("customer", value?._id);
            }}
            setShowAddCliente={setShowAddCliente}
          />
        </MDBox>
      )}
      <Footer />
    </DashboardLayout>
  );
}
